/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2024
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

/**
 * The prefixes that Tooling might care about when running as an MFE
 */
export const enum MfePrefix {
  // This is the prefix that must be added when retrieving initial configuration
  // and setting up the Axios interceptor when Tooling is executing as an MFE
  // (Micro Front-End) as part of watsonx Orchestrate.
  // In this environment, all API calls need to be proxied to the Tooling
  // server, and this prefix lets the WXO framework know where to proxy the calls.
  ASSISTANTS = '/mfe_assistants'
}
